import { cEl } from '../../../../../util';
import { testRenderer } from '../../index';
import { getCurrTest, getNextTest } from '../../constants';

function SelfDiagnosticTestFooter() {
    const footer = cEl('div');
    footer.classList.add('self-diagnostic-footer');
    footer.innerHTML = `<div>예상 소요 시간 <span>5~10분</span></div>`;

    const startButton = cEl('button');
    startButton.classList.add('button', 'brand-button');
    startButton.innerHTML = '자가진단 테스트 시작하기';
    startButton.addEventListener('click', e => {
        const nextTest = getNextTest(getCurrTest().key);
        testRenderer(nextTest);
    });

    footer.appendChild(startButton);
    return footer;
}

export default SelfDiagnosticTestFooter;
